<template>
  <b-card no-title>
    <b-card-text>
      <b-alert show variant="danger">
        <p>
          <strong
            >If a user is deleted, you can use the "Create User" option in order to add them again
            at any time. Are you sure you want to delete this user?</strong
          >
        </p>
      </b-alert>
      <b-form @submit="onSubmit">
        <b-button :disabled="busy" class="float-right" type="submit" variant="danger"
          >Delete
          <div v-if="busy" style="display: inline;">
            <b-spinner small></b-spinner>
            <span class="sr-only">Deleting...</span>
          </div>
        </b-button>
      </b-form>
    </b-card-text>
  </b-card>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'DeleteUserModal',
    props: {
      userId: String,
    },
    data() {
      return {
        busy: false,
      };
    },
    computed: {
      ...mapGetters(['userForm']),
    },
    methods: {
      async onSubmit() {
        this.busy = true;
        event.preventDefault();
        await axios
          .delete(`/api/salesforce/users/${this.userForm.ID}`)
          .then(results => {
            this.$emit('userDeleted', results.data);
          })
          .catch(err => {
            console.log(err);
            this.$bvToast.toast(`Could Not Delete User - ${err.response.data.errorMessage}`, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'danger',
            });
          });
        this.busy = false;
      },
    },
  };
</script>
